import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { DarkSkeleton } from '@eika/skeleton';

import { Content } from '../../components/shared/Content';
import EFakturaReservationsHeader from './EFakturaReservationsHeader';

const EFakturaReservationsSkeleton: React.FC = () => {
    return (
        <>
            <EFakturaReservationsHeader />
            <Content>
                <DarkSkeleton height={17} width={127} className="efaktura-reservations__search-label--skeleton" />
                <DarkSkeleton height={48} width="100%" />
            </Content>
            <Content>
                <DarkSkeleton height={24} width={194} className="efaktura-reservations__title-skeleton" />
                <div className="efaktura-reservation-item--skeleton">
                    <Skeleton height={16} width="60%" />
                </div>
                <div className="efaktura-reservation-item--skeleton">
                    <Skeleton height={16} width="35%" />
                </div>
                <div className="efaktura-reservation-item--skeleton">
                    <Skeleton height={16} width="60%" />
                </div>
            </Content>
        </>
    );
};

export default EFakturaReservationsSkeleton;
